import { ACTION_CREATE, ACTION_EDIT, ACTION_DELETE } from '../../request';
import { Voter } from '../voter';

export class CollectionsVoter extends Voter {
    supports(request) {
        return request.resource === 'collections';
    }

    vote(request) {
        if (request.role === 'basic') {
            if (request.includes(ACTION_CREATE)) {
                return false;
            }

            if (request.includes(ACTION_EDIT)) {
                return false;
            }
        }

        if (request.includes(ACTION_EDIT)) {
            if (!this.canEdit(request)) {
                return false;
            }
        }

        if (request.includes(ACTION_DELETE)) {
            if (!this.canDelete(request)) {
                return false;
            }
        }

        return true;
    }

    /**
     * @param {AccessPermissionRequest} request
     * @returns {boolean}
     */
    canEdit(request) {
        return request.subject && !request.subject.default;
    }

    /**
     * @param {AccessPermissionRequest} request
     * @returns {boolean}
     */
    canDelete(request) {
        return !request.subject.default;
    }
}
